import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface Participants {
  id: string;
  leaveTime: string;
}
export type ParticipantsState = {
  data: Participants[];
};

const initialState: ParticipantsState = {
  data: [],
};

export const participantSlice = createSlice({
  initialState,
  name: "participant",
  reducers: {
    upSertParticipantLeaveTime: (
      state,
      action: PayloadAction<Participants>
    ) => {
      const { id, leaveTime } = action.payload;
      const participantIndex = state.data.findIndex((p) => p.id === id);

      if (participantIndex >= 0) {
        state.data[participantIndex] = {
          ...state.data[participantIndex],
          leaveTime,
        };
      } else {
        state.data.push({ id, leaveTime });
      }
    },
    resetParticipantLeaveTime: (state) => {
      state.data = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const { upSertParticipantLeaveTime, resetParticipantLeaveTime } =
  participantSlice.actions;
export default participantSlice.reducer;
